import { makeOptions } from './config'

export default {
  props: {
    data: {type: Object, default: () => null}
  },
  data: () => ({
    chart: null,
    isEmpty: false,
  }),
  watch: {
    '$props.data': {
      immediate: true,
      deep: true,
      handler() {
        this.draw()
      }
    },
  },
  methods: {
    draw() {
      const isEmpty = this.checkIsEmpty()
      this.isEmpty = isEmpty
      if (isEmpty) return  // 空数据不执行
      this.$nextTick(() => { // 延迟dom渲染后
        if (!this.chart) this.chart = window.echarts.init(this.$refs.chart)
        const data = this.$props.data
        const config = makeOptions(data)
        this.chart.setOption(config, true)
        window.addEventListener('resize', this.setResize)
      })
    },
    checkIsEmpty() { // 判断是否为空
      const data = this.$props.data
      if (!data) return true // 数据空
      return (!data?.total?.commodityCount && !data?.new?.commodityCount)
    },
    setResize() {
      this.chart.resize()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setResize)
  }
}
